import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icon from "../../common/Icon";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

interface RecentAuditReportsProps {
  data: any[];
  totalCount: number;
  isLoading?: boolean;
  onDownload?: (audit: any) => void;
}

function formatMonthYear(audit: any): string {
  if (!audit.month || !audit.year) return "-";
  return `${audit.month} (${audit.year})`;
}

const RecentAuditReports: React.FC<RecentAuditReportsProps> = ({
  data,
  totalCount,
  isLoading,
  onDownload,
}) => {
  const items = data || [];

  return (
    <div className="audit-reports-section">
      <div className="section-card">
        <div className="section-header">
          <div className="section-title">Recent Audit Reports</div>
          <div className="section-subtitle">
            {/* {totalCount > 0
              ? `Showing ${items.length} of ${totalCount} most recently completed audits`
              : "10 most recently completed audits"} */}
              View recently completed audits with final audit status and access their reports.
          </div>
        </div>

        {isLoading ? (
          <div className="section-loading">
            <div className="spinner-border text-secondary" role="status" />
            Loading...
          </div>
        ) : (
          <div className="audit-reports-table-wrapper">
            {items.length === 0 ? (
              <div className="empty-state-message">
                The final audit report has not yet been published.
              </div>
            ) : (
            <table className="audit-reports-table">
              <thead>
                <tr>
                  <th style={{ width: 160 }}>Month & Year</th>
                  <th style={{ width: 193 }}>Company</th>
                  <th style={{ width: 193 }}>Associate Company</th>
                  <th style={{ width: 133 }}>Location</th>
                  <th style={{ width: 183 }}>Vendor Category</th>
                  <th style={{ width: 164 }}>Vendor</th>
                  <th style={{ width: 98 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((audit: any, idx: number) => {
                    const companyName = audit.company ? audit.company.name : "-";
                    const associateCompanyName = audit.associate_company ? audit.associate_company.name : "-";
                    const locationName = audit.location ? audit.location.name : "-";
                    const vendorCategoryName = audit.vendor_category ? audit.vendor_category.name : "-";
                    const vendorName = audit.vendor_registration ? audit.vendor_registration.vendor_name : "-";
                    return (
                      <tr key={audit.id || idx}>
                        <td>{formatMonthYear(audit)}</td>
                        <td title={companyName}>{companyName}</td>
                        <td title={associateCompanyName}>{associateCompanyName}</td>
                        <td title={locationName}>{locationName}</td>
                        <td title={vendorCategoryName}>{vendorCategoryName}</td>
                        <td title={vendorName}>{vendorName}</td>
                        <td onClick={() => onDownload && onDownload(audit)}>
                          <Icon
                            name='downloadIcon'
                            className="download-icon"
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentAuditReports;
